<mat-card class="card">
    <header>
        <h3>Log On</h3>
    </header>
    <form
            style="padding-top: 5%;"
            [formGroup]="logonForm"
            (ngSubmit)="confirm()">
        <div>
            <input placeholder="Email" formControlName='email'>
            <input type="password" placeholder="Password" formControlName='password'>
        </div>
        <div class="submitForm">
            <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
            <button *ngIf="!loading" class="button" routerLinkActive="router-link-active">{{'LOG_ON_B1' | translate}}</button>
        </div>
    </form>
    <div class="forgotPassword">
        <div class="loginSeparator">
            <span class="textInSeparator">{{'LOG_ON_OR' | translate}}</span>
        </div>
        <button class="button secondary" (click)="forgotPassword()">{{'LOG_ON_B2' | translate}}</button>
        <button class="button secondary" (click)="emailNotConfirmed()" style="margin-top: 1rem;">{{'LOG_ON_ERR4' | translate}}</button>
    </div>
</mat-card>
